import { routes as sale_orders } from './SaleOrders';

export default [
  ...sale_orders,
]